import { IconButton } from "@circleco/compass/components/IconButton";

import { t } from "@/i18n-js/instance";

import { useCircleAiStore } from "../useCircleAiStore";
import { useIsCircleAiPageRoute } from "../useIsCircleAiPageRoute";

export const NewChatButton = () => {
  const startNewChat = useCircleAiStore(s => s.startNewChat);
  const { isFullPageAiRoute } = useIsCircleAiPageRoute();
  const label = t("circle_ai_home.new_chat");

  return (
    <IconButton
      icon="circle-plus-filled"
      variant="ghost"
      onClick={() => startNewChat({ openPanel: !isFullPageAiRoute })}
      title={label}
      aria-label={label}
    />
  );
};
